import { render, staticRenderFns } from "./parametriPolize.vue?vue&type=template&id=0459c668&"
import script from "./parametriPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./parametriPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports